<template>
    <div class="w-100">
        <v-select    
            label="name"
            :options="parcelType"
            :class="{ 'is-invalid bd-danger': error.status }"
            :value="data.remark"
            @keyup.native="seleted($event, 'onKeyUp')"
            @input="seleted($event, 'onSeleted')" >
        </v-select>
        <template v-if="seletedKey === 'OTHER'">
            <label for="input-live"><small class="text-danger">*</small> รายละเอียด</label>
            <input type="text" class="form-control"
                :class="{ 'is-invalid': error.status }"
                v-model="data.remark"
                placeholder="เช่น รองเท้า 1 คู่ , เสื้อแขนยาว 1 ตัว  เป็นต้น" />
        </template>
        <small class="text-danger" 
            v-for="(msg, index) in error.data" :key="index" >
            {{msg}}
        </small>
    </div>
</template>
<script>
import parcelType from '@/config/parcelType'
export default {
    name: "InputParcelType",
    props:{
        data: Object,
        error: Object
    },
    data(){
        return {
            seletedKey: null,
            parcelType: parcelType,
        }
    },
    methods:{
        seleted( data , event ){
            this.seletedKey = event === 'onKeyUp' ? null : data.key
            if( event === 'onKeyUp' || this.seletedKey === 'OTHER' ){
                this.data.remark = ''
            }else{
                this.data.remark = data.name
            }
            this.data.category = data.key
        }
    }
    

}
</script>